var path = 'views/value/time.html';
var html = "<div class=form-group> <label for=fieldValue>Wert</label> <input type=text class=form-control id=fieldValue dn-timepicker=HH:mm min-time=00:00 steps=15 ng-model=models.elementCopy.value autocomplete=off> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;